"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItem = void 0;
var AccordionItem_1 = __importDefault(require("./AccordionItem"));
exports.AccordionItem = AccordionItem_1.default;
exports.default = AccordionItem_1.default;
//# sourceMappingURL=index.js.map